/**
 * PageHeader — tüm ekranlar için tutarlı sayfa başlığı.
 * Marka dili: başlık koyu, opsiyonel ikon rozeti (brand), sağda aksiyon alanı.
 *
 * Mobil: kök eleman `min-w-0 flex-1` taşır — esnek bir satırda (başlık +
 * sağdaki düğmeler) başlık küçülebilir ve düğmeleri ekran dışına itmez.
 *
 * @param {string} title
 * @param {string} [subtitle]
 * @param {React.ReactNode} [icon]      - lucide ikon elementi
 * @param {React.ReactNode} [actions]   - sağ üst aksiyon butonları
 * @param {'light'|'brand'} [variant]   - açık zemin veya marka (koyu) zemin
 * @param {string} [subtitleClassName]  - ör. "hidden sm:block" (mobilde gizle)
 */
import { cn } from '@/lib/utils';

export default function PageHeader({ title, subtitle, icon, actions, variant = 'light', className, subtitleClassName }) {
  const isBrand = variant === 'brand';
  return (
    <div
      className={cn(
        'flex items-start justify-between gap-3 sm:gap-4 min-w-0 flex-1',
        isBrand ? 'text-white' : 'text-slate-900',
        className
      )}
    >
      <div className="flex items-center gap-3 min-w-0">
        {icon && (
          <div
            className={cn(
              'w-10 h-10 sm:w-11 sm:h-11 rounded-xl hidden min-[360px]:flex items-center justify-center shrink-0',
              isBrand ? 'bg-white/10 text-white' : 'bg-brand-50 text-brand-900'
            )}
          >
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl font-bold tracking-tight truncate">{title}</h1>
          {subtitle && (
            <p className={cn('text-sm truncate', isBrand ? 'text-white/70' : 'text-slate-500', subtitleClassName)}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
